import DeskEmptyState from './DeskEmptyState';

export default DeskEmptyState;
